module.exports = __webpack_public_path__ + "img/handraw_gout.56895079.svg";